module.exports = __webpack_public_path__ + "static/media/star--illustrated.3aecf903.svg";